import {
  APP_ZONES,
  PermissionConfig,
  WidgetNames,
  WorkflowConfig,
  WorkflowPageConfig,
} from '@finxone-platform/shared/sys-config-types';

export const getV1_0_163ToV1_0_164 = (workflowConfig: WorkflowConfig) => {
  const oneToOneKeys = Object.keys(workflowConfig);
  const mappingObject = {};
  // Assign mappings to not modify this version upgrade
  oneToOneKeys.forEach((key) => {
    Object.assign(mappingObject, {
      [key]: key,
    });
  });
  return {
    ...mappingObject,
    // add new version number
    version: {
      key: 'version',
      transform: function () {
        return 'v1.0.164';
      },
    },
    permissionSections: {
      key: 'permissionSections',
      transform: function (permissionSection: PermissionConfig): PermissionConfig {
        const { roles, subscriptions } = permissionSection;
        roles.forEach((item) => {
          const paymentZone = item.zones[APP_ZONES.VERIFICATION];
          if (paymentZone) {
            const mobilePages = paymentZone?.canvases?.subscription?.['default']?.mobile?.pages as
              | WorkflowPageConfig[]
              | undefined;
            const desktopPages = paymentZone?.canvases?.subscription?.['default']?.desktop?.pages as
              | WorkflowPageConfig[]
              | undefined;
            const tabletPages = paymentZone?.canvases?.subscription?.['default']?.tablet?.pages as
              | WorkflowPageConfig[]
              | undefined;
            if (mobilePages?.length) {
              modifyPage(mobilePages);
            }
            if (desktopPages?.length) {
              modifyPage(desktopPages);
            }
            if (tabletPages?.length) {
              modifyPage(tabletPages);
            }
          }
        });
        return <PermissionConfig>{
          zones: permissionSection.zones,
          subscriptions,
          roles,
        };
      },
    },
  };
};

/**
 * Modifies specific widgets in the provided workflow pages by updating their text content,
 * based on matching URL segments and widget names.
 *
 * Currently targets:
 * - Pages with 'sumsub-workflow' in their URL
 * - Pages with 'verify' in their URL
 * For both, updates the SUMSUB_WIDGET's display message.
 */
const modifyPage = (pagesArray: WorkflowPageConfig[]): WorkflowPageConfig[] => {
  /**
   * Finds a page by a partial URL match and updates a specific widget's text content.
   *
   */
  const updateWidgetText = (pageUrlIncludes: string, widgetName: string, text: string): void => {
    const page = pagesArray.find((p) => p?.pageConfiguration?.url?.includes(pageUrlIncludes));
    if (!page?.widgets) return;

    const widget = page.widgets.find((w) => w.name === widgetName);
    if (widget) {
      widget.widgetConfiguration.attributes.widgetProperties = { textContent: text };
    }
  };

  const message =
    'Please wait while we process your application. You will be redirected once your application has been approved.';

  // Update SUMSUB widgets on both internal KYC and third-party verification pages
  updateWidgetText('sumsub-workflow', WidgetNames.SUMSUB_WIDGET, message);
  updateWidgetText('verify', WidgetNames.SUMSUB_WIDGET, message);

  return pagesArray;
};
